import React, { useState, useEffect } from 'react';
import './App.css';
import CustomNavbar from './pages/Navbar';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import Projects from './pages/Projects';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { project_types } from "./data/projects-types";
import Footer from "./pages/Footer";
import ProjectList from "./pages/ProjectList";
import ProjectDetails from "./pages/ProjectDetails";
import About from "./pages/About";
import WhereWeWork from "./pages/WhereWeWork";
import TrainingCenter from "./pages/TrainingCenter";
import OurImpact from "./pages/OurImpact";
import ImpactStoryDetail from "./pages/ImpactStoryDetail";
import HowToHelp from "./pages/HowToHelp";
import CsrSuccessStories from "./pages/CsrSuccessStories";
import ScrollToTop from "./components/ScrollToTop";

function App() {
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('theme') === 'dark';
    });

    useEffect(() => {
        document.body.className = darkMode ? 'dark' : 'light';
        localStorage.setItem('theme', darkMode ? 'dark' : 'light');
    }, [darkMode]);

    const toggleTheme = () => {
        setDarkMode(prevMode => !prevMode);
    };

    return (
        <Router>
            <div className="App">
                <ScrollToTop />
                <CustomNavbar darkMode={darkMode} toggleTheme={toggleTheme} projects={project_types} />
                <main style={{ padding: '0px' }}>
                    <Routes>
                        <Route path="/" element={<Home darkMode={darkMode} />} />
                        <Route path="/about" element={<About darkMode={darkMode} />} />
                        <Route path="/contact" element={<ContactUs darkMode={darkMode} />} />
                        <Route path="/programs" element={<Projects darkMode={darkMode} />} />
                        <Route path="/programs/:project_type" element={<ProjectList darkMode={darkMode} />} />
                        <Route path="/project-details/:project_id" element={<ProjectDetails darkMode={darkMode} />} />
                        <Route path="/where-we-work" element={<WhereWeWork darkMode={darkMode} />} />
                        <Route path="/training-center" element={<TrainingCenter darkMode={darkMode} />} />
                        <Route path="/our-impact" element={<OurImpact darkMode={darkMode} />} />
                        <Route path="/our-impact/:story_id" element={<ImpactStoryDetail darkMode={darkMode} />} />
                        <Route path="/how-to-help" element={<HowToHelp darkMode={darkMode} />} />
                        <Route path="/csr-success-stories" element={<CsrSuccessStories darkMode={darkMode} />} />
                    </Routes>
                </main>
                <Footer darkMode={darkMode} />
            </div>
        </Router>
    );
}

export default App;
